import axios from '@/axios.js'

export default {
  fetchQueueMissed: ({ commit }, warehouse) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`sales-and-purchase/drcc/queue-missed/${warehouse}`)
        .then(res => {
          console.log({res})
          commit('FETCH_QUEUE_MISSED', res.data.data)
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  },
}